module.exports = __webpack_public_path__ + "static/media/uiux.3a879e34.svg";